
import { Button } from "../ui/button";
import { useCallback } from "react";

interface KeyboardKeyProps {
  letter: string;
  status: "correct" | "wrong-position" | "incorrect" | "empty";
  onClick: (key: string) => void;
}

export const KeyboardKey = ({ letter, status, onClick }: KeyboardKeyProps) => {
  // Ensure we apply the correct color class based on status
  const colorClass = 
    status === "correct" ? "bg-success text-white" :
    status === "wrong-position" ? "bg-warning text-white" :
    status === "incorrect" ? "bg-destructive text-white" :
    "bg-gray-100 hover:bg-gray-200"; 

  // Memoize the click handler to prevent unnecessary re-renders
  const handleClick = useCallback(() => {
    onClick(letter);
  }, [letter, onClick]);

  return (
    <Button
      type="button"
      variant="outline"
      className={`keyboard-key p-0 flex-1 min-w-0 text-md font-extrabold ${colorClass} active:animate-key-press active:scale-90 active:bg-gray-100 active:shadow-[inset_0_3px_6px_rgba(0,0,0,0.4)] transition-all duration-150`}
      onClick={handleClick}
    >
      {letter.toUpperCase()}
    </Button>
  );
};
